import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ImportConfigurationTemplateService } from '../import-configuration-template.service';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ModalService } from 'src/app/base/shared/modal/modal.service';
import { DataManager } from '@syncfusion/ej2-data';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { GridModule, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { ImportConfigurationDTO, ImportConfigurationTransferType, ImportType } from 'src/app/base/models/models.swagger.generated';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { getNavisionTempalteIcon } from '../../shared/import-configuration.util';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';

export type ImportTypeEnumFilter = {
  importType: ImportType;
}

@Component({
    selector: 'app-import-configuration-templates',
    templateUrl: './import-configuration-templates.component.html',
    styleUrls: ['./import-configuration-templates.component.scss'],
    imports: [GridModule, TranslateModule]
})

export class ImportConfigurationTemplatesComponent extends GridBaseComponent<any> implements OnInit {

  public checkBoxFilter = GridConstantsFactory.createCheckBoxFilter();
  public TransferType = ImportConfigurationTransferType;
  public ImportType = ImportType;

  protected override initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }

  protected override getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

  @Output() rowSelected = new EventEmitter<any>();

  constructor(
    translateService: TranslateService,
    protected importConfigurationService: ImportConfigurationTemplateService,
    protected spinnerService: SpinnerService,
    protected modalService: ModalService
  ) {
    super(translateService, importConfigurationService);
    this.addIndexFindColumnName = 'id';
  }

  ngOnInit() {
    this.isActiveColumnName = 'configurationName';
    this.addIndexFindColumnName = 'configurationName';
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.importConfigurationService, this.spinnerService),
    });
  }

  public getTransferTypeName(transferType: number): string {
    return 'i18n.shared.import-config-transfer-types.' + ImportConfigurationTransferType[transferType];
  }

  public onRowSelected(args: RowSelectEventArgs): void {
    this.rowSelected.emit(args.data);
  }

  public formatFilterImportType(importTypeEnumFilter: ImportTypeEnumFilter): string {
    if (!importTypeEnumFilter) {
      return '';
    }
    return this.translateService.instant('i18n.shared.import-types.' + ImportType[importTypeEnumFilter.importType]);
  }

  public getNavisionTempalteIcon(config: ImportConfigurationDTO): string {
    return getNavisionTempalteIcon(config);
  }
}
